import { memo } from 'react';

import { ShareDesignImageButton } from '~/components/ShareModal/components/ShareDesignImageButton';
import { useShareBoardDesign } from '~/components/SharePrivateBoardModal/ShareBoardDesignProvider';

/** Board-cover picker (the board's OWN cover via the board-cover mutations, not the share link), bound to the board design context. */
export const ShareBoardDesignCoverButton = memo(() => {
  const { coverDisabled, coverSrc, designSettingsEnabled, handleClearCover, handleSelectCover } = useShareBoardDesign();

  return (
    // No brand-kit `options` on the cover: setting a board cover requires a clipId, but brand
    // context values carry at most an assetId — same gap as the collection's cover picker.
    <ShareDesignImageButton
      data-testid="SHARE_BOARD_DESIGN_COVER_ROW"
      disabled={coverDisabled}
      emptyLabel="Choose cover"
      imageSrc={coverSrc}
      onClear={handleClearCover}
      onSelect={handleSelectCover}
      selectModalConfirmLabel="Use as cover"
      selectModalTitle="Select a cover image"
      selectTestId="SHARE_BOARD_DESIGN_COVER_SELECT"
      showUpsell={!designSettingsEnabled}
    />
  );
});

ShareBoardDesignCoverButton.displayName = 'ShareBoardDesignCoverButton';
